var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8516 17.7793L14.3613 13.2891C14.25 13.2148 14.1387 13.1406 14.0273 13.1406H13.5449C14.6953 11.8047 15.4375 10.0234 15.4375 8.09375C15.4375 3.86328 11.9492 0.375 7.71875 0.375C3.45117 0.375 0 3.86328 0 8.09375C0 12.3613 3.45117 15.8125 7.71875 15.8125C9.64844 15.8125 11.3926 15.1074 12.7656 13.957V14.4395C12.7656 14.5508 12.8027 14.6621 12.877 14.7734L17.3672 19.2637C17.5527 19.4492 17.8496 19.4492 17.998 19.2637L18.8516 18.4102C19.0371 18.2617 19.0371 17.9648 18.8516 17.7793ZM7.71875 14.0312C4.41602 14.0312 1.78125 11.3965 1.78125 8.09375C1.78125 4.82812 4.41602 2.15625 7.71875 2.15625C10.9844 2.15625 13.6562 4.82812 13.6562 8.09375C13.6562 11.3965 10.9844 14.0312 7.71875 14.0312Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeSearch);
export default __webpack_public_path__ + "static/media/Large_Search.dbfd94ccc15e0aae6c9db7676ac36dea.svg";
export { ForwardRef as ReactComponent };